function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgNok = function SvgNok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M8.819,322.783c14.812,54.959,47.457,102.593,91.355,136.322V322.783H8.819z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M233.739,511.026C241.077,511.658,248.498,512,256,512c118.279,0,217.805-80.221,247.181-189.217 H233.739V511.026z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M503.181,189.217C473.805,80.221,374.279,0,256,0c-7.502,0-14.923,0.342-22.261,0.974v188.243 H503.181z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M100.174,52.895c-43.898,33.73-76.543,81.363-91.355,136.322h91.355V52.895z"
  })), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M509.833,222.609H200.349h-0.001V6.085c-23.658,5.246-46.087,13.749-66.783,25.042v191.48v0.001 H2.167C0.742,233.539,0,244.683,0,256s0.742,22.461,2.167,33.391h131.397h0.001v191.481c20.696,11.292,43.125,19.797,66.783,25.042 V289.394v-0.002h309.485C511.256,278.461,512,267.317,512,256S511.256,233.539,509.833,222.609z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NOK.5fc94e90.svg";
export { ForwardRef as ReactComponent };